let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hDd1X")).then(() => parcelRequire('kAQEs'));